import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  placeholder: string;
  label?: string;
  onChange: (event: any) => void;
  value: string;
  name: string;
  required: boolean;
  helperText: string;
  disabled?: boolean;
  rows: number;
}

interface StyledInputProps {
  helperText: string;
}

const TextArea = ({
  onChange,
  rows,
  placeholder,
  label,
  value,
  name,
  required,
  helperText,
  disabled,
}: Props) => {
  return (
    <>
      <InputFieldWrapper>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <InputField
          disabled={disabled}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          name={name}
          helperText={helperText}
          autoComplete="off"
          rows={rows}
        />
        {helperText && <Error>{helperText}</Error>}
      </InputFieldWrapper>
    </>
  );
};

const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const InputField = styled.textarea<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 0.75rem;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  resize: none;
  border: 0.0625rem solid
    ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 0.8125rem;
  line-height: 1rem;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 0.125rem;
  }
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default TextArea;
